import { render, staticRenderFns } from "./ChristmasCardsBanner.vue?vue&type=template&id=1226045c&name=christmas-cards-banner&"
import script from "./ChristmasCardsBanner.vue?vue&type=script&lang=js&"
export * from "./ChristmasCardsBanner.vue?vue&type=script&lang=js&"
import style0 from "./ChristmasCardsBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports